import React, { useState } from "react";
import { snoozePastDueBanner } from "./header-service";
import { getListOfInvoices } from "@/app/(general-header)/subscription/subscription-service";

const PAST_DUE_STATUSES: string[] = ["open"];

type PastDueNotificationProps = {
  onSnooze: () => void;
};

const PastDueNotification = ({ onSnooze }: PastDueNotificationProps) => {
  const [isPayLoading, setIsPayLoading] = useState(false);

  const handleSnooze = async () => {
    try {
      const response = await snoozePastDueBanner();
      const data = await response.json();
      if (data.success) {
        onSnooze();
      }
    } catch (err) {
      console.error("Failed to snooze past due banner", err);
    }
  };

  const handlePay = async () => {
    setIsPayLoading(true);
    try {
      const response = await getListOfInvoices();
      const result: InvoiceList = await response.json();
      const pastDueInvoice = result.data?.find(invoice => PAST_DUE_STATUSES.includes(invoice.status));
      if (pastDueInvoice) {
        location.href = `/subscription/invoice?invoiceId=${pastDueInvoice.id}&utm_medium=past_due_banner`;
      } else {
        location.href = "/management-subscription?utm_source=top_bar_notice";
      }
    } catch (err) {
      console.error("Failed to fetch invoices", err);
      location.href = "/management-subscription?utm_source=top_bar_notice";
    }
  };

  return (
    <div className={"font-jost bg-white max-lg:pt-4 max-lg:pb-6 max-lg:relative shadow-[inset_0_1px_0_0_#E0E0E0]"}>
      <div className={"lg:relative w-full max-w-[1360px] lg:mx-auto lg:py-12"}>
        <button
          className={"m-0 p-0 border-0 absolute right-3 lg:right-6 top-3 cursor-pointer lg:top-3"}
          onClick={handleSnooze}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={"size-6"}>
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#898994"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className={"max-w-[287px] lg:flex lg:items-end lg:justify-between lg:max-w-[1086px] pl-4 lg:pl-8"}>
          <div className={"mb-3 lg:mb-0 flex gap-2 items-start lg:max-w-[487px]"}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className={"size-6 lg:size-10 shrink-0"}>
              <path
                d="M21.0502 18.7069L13.0613 3.87094C12.4951 2.81906 10.9866 2.81906 10.4199 3.87094L2.43146 18.7069C2.30851 18.9352 2.24687 19.1916 2.25256 19.4508C2.25824 19.7101 2.33105 19.9635 2.46389 20.1863C2.59673 20.409 2.78504 20.5935 3.01047 20.7217C3.23589 20.85 3.49071 20.9176 3.75005 20.918H19.7293C19.9888 20.918 20.2439 20.8507 20.4697 20.7226C20.6954 20.5945 20.8841 20.4101 21.0172 20.1873C21.1503 19.9644 21.2233 19.7109 21.2291 19.4514C21.2349 19.1919 21.1733 18.9354 21.0502 18.7069ZM11.7408 18.6211C11.5554 18.6211 11.3742 18.5661 11.22 18.4631C11.0658 18.3601 10.9457 18.2137 10.8747 18.0424C10.8037 17.8711 10.7852 17.6826 10.8213 17.5007C10.8575 17.3188 10.9468 17.1518 11.0779 17.0207C11.209 16.8896 11.3761 16.8003 11.5579 16.7641C11.7398 16.7279 11.9283 16.7465 12.0996 16.8175C12.2709 16.8884 12.4173 17.0086 12.5203 17.1627C12.6234 17.3169 12.6783 17.4982 12.6783 17.6836C12.6783 17.9322 12.5796 18.1707 12.4037 18.3465C12.2279 18.5223 11.9895 18.6211 11.7408 18.6211ZM12.759 9.19219L12.4899 14.9109C12.4899 15.1098 12.4109 15.3006 12.2702 15.4413C12.1296 15.5819 11.9388 15.6609 11.7399 15.6609C11.541 15.6609 11.3502 15.5819 11.2096 15.4413C11.0689 15.3006 10.9899 15.1098 10.9899 14.9109L10.7208 9.19453C10.7148 9.05793 10.7363 8.92151 10.7841 8.79341C10.8319 8.6653 10.905 8.54813 10.9991 8.44888C11.0931 8.34963 11.2062 8.27033 11.3315 8.2157C11.4569 8.16108 11.5919 8.13225 11.7286 8.13094H11.7385C11.8762 8.13087 12.0124 8.15869 12.139 8.21272C12.2656 8.26675 12.38 8.34587 12.4752 8.44531C12.5704 8.54475 12.6444 8.66245 12.6929 8.7913C12.7413 8.92015 12.7632 9.05748 12.7571 9.195L12.759 9.19219Z"
                fill="#F33424"
              />
            </svg>
            <div>
              <div className={"text-[#F33424] text-sm font-medium leading-5 mb-2 lg:text-[22px] lg:leading-7"}>
                Your BOTB Pass is overdue
              </div>
              <div className={"text-[#4c4c52] text-[11px] font-normal leading-[14px] lg:text-base lg:leading-5.5"}>
                You're currently missing entries for all BOTB competitions. Fix your payment to get back in.
              </div>
            </div>
          </div>
          <div className={"max-lg:pl-8 lg:max-w-[265px]"}>
            <button
              onClick={handlePay}
              disabled={isPayLoading}
              className="theme-btn theme-btn-primary theme-btn-xs lg:theme-btn-2lg min-w-[120px] lg:min-w-[265px] uppercase">
              {isPayLoading ? "Loading..." : "PAY NOW"}
              {/*<svg*/}
              {/*  xmlns="http://www.w3.org/2000/svg"*/}
              {/*  width="16"*/}
              {/*  height="16"*/}
              {/*  viewBox="0 0 16 16"*/}
              {/*  fill="none"*/}
              {/*  className={"size-4 lg:size-6 shrink-0"}>*/}
              {/*  <path*/}
              {/*    d="M4.66797 4.66699L8.0013 8.00033L4.66797 11.3337M8.66797 4.66699L12.0013 8.00033L8.66797 11.3337"*/}
              {/*    stroke="white"*/}
              {/*    strokeWidth="1.5"*/}
              {/*    strokeLinecap="round"*/}
              {/*    strokeLinejoin="round"></path>*/}
              {/*</svg>*/}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PastDueNotification;
